import { render, staticRenderFns } from "./ReceptionDateDialog.vue?vue&type=template&id=54314135"
import script from "./ReceptionDateDialog.vue?vue&type=script&lang=js"
export * from "./ReceptionDateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports